package org.mkui.colormap

enum class Matching {
    EXACT, CLOSEST
}